export default __webpack_public_path__ + "static/media/chronicle_award.b5a24360.png";